document.addEventListener("DOMContentLoaded", () => {
  const STORAGE_KEY = "vc_recent_vehicle_searches";
  const MAX_RECENT = 5;

  const regInput = document.querySelector("[data-reg-input]");
  const dropdown = document.querySelector("[data-reg-dropdown]");
  const recentList = document.querySelector("[data-reg-recent-list]");
  const collectionInfo = document.getElementById("collectionInfo");
  const regSubmitButton = document.querySelector(".site-header-reg-lookup__submit");

  if (!regInput) return; // Reg lookup widget isn't on this page for some reason

  // Guards against sending multiple paid webhook/DVLA lookups for a single
  // submission (rapid double-clicks on Go, mashing Enter, etc). While a
  // request is in flight, further submissions are ignored and the button is
  // disabled so it's obvious to the customer that something is happening.
  let isLookingUp = false;

  // API endpoint
  const webhookUrl =
    "https://hook.eu1.make.com/v341bhgchudst1iugluhhfislr97ku4g"; // Replace with your actual webhook URL

  // ---------- Recent search storage (guest / localStorage) ----------

  function getGuestHistory() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function saveGuestHistory(entry) {
    try {
      let history = getGuestHistory();
      history = history.filter(
        (item) => (item.reg || "").toUpperCase() !== (entry.reg || "").toUpperCase()
      );
      history.unshift(entry);
      history = history.slice(0, MAX_RECENT);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
    } catch (e) {
      console.error("Unable to save recent search:", e);
    }
  }

  // ---------- Recent search storage (logged-in customer) ----------
  // Populated server-side in sections/static-header.liquid from the
  // customer's `custom.recent_vehicle_searches` metafield (written by the
  // Make.com scenario after a successful lookup while logged in).

  function getCustomerHistory() {
    const el = document.getElementById("customer-recent-searches-data");
    if (!el) return [];
    try {
      const data = JSON.parse(el.textContent);
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function getMergedHistory() {
    const combined = [...getCustomerHistory(), ...getGuestHistory()];
    const seen = new Set();
    const merged = [];

    combined
      .slice()
      .sort((a, b) => new Date(b.searched_at || 0) - new Date(a.searched_at || 0))
      .forEach((item) => {
        const key = (item.reg || "").toUpperCase();
        if (key && !seen.has(key)) {
          seen.add(key);
          merged.push(item);
        }
      });

    return merged.slice(0, MAX_RECENT);
  }

  // ---------- Dropdown rendering ----------

  function escapeHtml(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, (c) => (
      { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]
    ));
  }

  function renderRecentList() {
    if (!recentList) return;
    const history = getMergedHistory();

    if (history.length === 0) {
      recentList.innerHTML =
        '<div class="reg-lookup-dropdown__empty">Your recent vehicle searches will appear here.</div>';
      return;
    }

    const itemsHtml = history
      .map((item) => {
        const label =
          [item.make, item.model].filter(Boolean).join(" ") ||
          item.title ||
          item.reg ||
          "Vehicle";
        const subParts = [item.year, item.colour].filter(Boolean).map(escapeHtml);
        const regHtml = item.reg
          ? `<span class="reg-lookup-recent-item__reg">${escapeHtml(item.reg.toUpperCase())}</span>`
          : "";
        const subText = [subParts.join(" • "), regHtml].filter(Boolean).join(" • ");
        const thumb = item.image
          ? `<img class="reg-lookup-recent-item__thumb" src="${escapeHtml(item.image)}" alt="${escapeHtml(label)}">`
          : `<span class="reg-lookup-recent-item__thumb reg-lookup-recent-item__thumb--placeholder">&#128663;</span>`;

        return `
          <button type="button" class="reg-lookup-recent-item" data-recent-handle="${escapeHtml(item.handle || "")}">
            ${thumb}
            <span class="reg-lookup-recent-item__meta">
              <span class="reg-lookup-recent-item__title">${escapeHtml(label)}</span>
              <span class="reg-lookup-recent-item__sub">${subText}</span>
            </span>
          </button>
        `;
      })
      .join("");

    recentList.innerHTML =
      '<div class="reg-lookup-dropdown__recent-heading">Recent searches</div>' + itemsHtml;

    recentList.querySelectorAll("[data-recent-handle]").forEach((button) => {
      button.addEventListener("click", () => {
        const handle = button.getAttribute("data-recent-handle");
        if (handle) {
          window.location.href = "/collections/" + handle;
        }
      });
    });
  }

  function hasActiveResult() {
    return !!(collectionInfo && collectionInfo.innerHTML.trim() !== "");
  }

  function showDropdown() {
    if (!dropdown) return;
    const showingResult = hasActiveResult();
    if (recentList) recentList.style.display = showingResult ? "none" : "";
    if (!showingResult) renderRecentList();
    dropdown.hidden = false;
  }

  function hideDropdown() {
    if (!dropdown) return;
    dropdown.hidden = true;
  }

  regInput.addEventListener("focus", showDropdown);
  regInput.addEventListener("click", showDropdown);

  // Let customers press Enter in the reg box instead of having to click Go.
  regInput.addEventListener("keydown", (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      lookupCar();
    }
  });

  document.addEventListener("click", (event) => {
    if (dropdown && !dropdown.hidden) {
      const wrapper = regInput.closest("[data-reg-lookup]");
      if (wrapper && !wrapper.contains(event.target)) {
        hideDropdown();
      }
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") hideDropdown();
  });

  // ---------- Mobile: collapse the reg box on scroll down ----------

  const regWrapper = regInput.closest("[data-reg-lookup]");
  const mobileQuery = window.matchMedia("(max-width: 989px)");
  let lastScrollY = window.scrollY;

  function handleScroll() {
    if (!regWrapper || !mobileQuery.matches) return;

    // Don't collapse mid-interaction
    if (document.activeElement === regInput || (dropdown && !dropdown.hidden)) {
      lastScrollY = window.scrollY;
      return;
    }

    const currentScrollY = window.scrollY;
    if (currentScrollY > lastScrollY && currentScrollY > 80) {
      regWrapper.classList.add("is-collapsed");
    } else if (currentScrollY < lastScrollY || currentScrollY <= 80) {
      regWrapper.classList.remove("is-collapsed");
    }
    lastScrollY = currentScrollY;
  }

  window.addEventListener("scroll", () => {
    window.requestAnimationFrame(handleScroll);
  }, { passive: true });

  mobileQuery.addEventListener("change", () => {
    if (regWrapper) regWrapper.classList.remove("is-collapsed");
  });

  // ---------- Keep sticky filters bar in sync with header height ----------
  // On collection pages the theme pins the filters bar (.productgrid--utils-sticky)
  // to a fixed `top` offset equal to the header's height in px, computed once
  // (on load) and never recalculated. When our reg box collapses/expands on
  // scroll, the header's real height changes but that offset doesn't — leaving
  // a gap (or overlap) between the header and the filters bar. We fix this by
  // recalculating the header height and nudging the offset ourselves whenever
  // our collapse/expand transition finishes.
  function syncStickyOffsets() {
    const header =
      document.querySelector("[data-site-header]") || document.querySelector("header.site-header");
    if (!header) return;
    const newHeight = Math.round(header.getBoundingClientRect().height);

    document.documentElement.style.setProperty("--header-height", newHeight + "px");

    const stickyNav = document.querySelector(".productgrid--utils-sticky");
    if (stickyNav) {
      stickyNav.style.top = newHeight + "px";
    }
  }

  if (regWrapper) {
    const inputGroupEl = regWrapper.querySelector(".site-header-reg-lookup__input-group");
    if (inputGroupEl) {
      inputGroupEl.addEventListener("transitionend", (event) => {
        if (event.propertyName === "max-height") syncStickyOffsets();
      });
    }
  }

  // ---------- Lookup ----------

  function timeoutPromise(ms) {
    return new Promise((_, reject) => {
      setTimeout(() => reject(new Error("Request timed out")), ms);
    });
  }

  async function lookupCar() {
    // Already have a request in flight for this widget — ignore extra
    // clicks/Enter presses instead of firing another (billed) lookup.
    if (isLookingUp) return;

    const regNumber = regInput.value.trim();

    if (!regNumber) {
      alert("Please enter a valid registration number.");
      return;
    }

    isLookingUp = true;
    if (regSubmitButton) {
      regSubmitButton.disabled = true;
      regSubmitButton.setAttribute("aria-busy", "true");
    }

    try {
      const response = await Promise.race([
        fetch(webhookUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            regNumber,
            // Included so the Make scenario can save this search against the
            // logged-in customer's metafield. Null for guests.
            customer_id: window.VC_CUSTOMER_ID || null,
          }),
        }),
        timeoutPromise(8000), // 8-second timeout
      ]);

      if (!response.ok) {
        console.error("Response status:", response.status, response.statusText);
        throw new Error("Failed to send registration number to the webhook.");
      }

      const responseBody = await response.json();
      console.log("Response body:", responseBody);

      processResult(responseBody, regNumber);
    } catch (error) {
      console.error("Error:", error);
      if (collectionInfo) {
        collectionInfo.innerHTML = `
                <div class="collection-details">
                    <h5>Sorry, our lookup service doesn't seem to be working at the moment. Please try again later or use the search bar.</h5>
                    <div class="button-group">
                        <span class="reset-button" onclick="resetForm()">Reset</span>
                    </div>
                </div>
            `;
        showDropdown();
      }
    } finally {
      // Always release the lock, even on timeout/error, so a genuine retry
      // is never blocked — only true duplicate submissions are.
      isLookingUp = false;
      if (regSubmitButton) {
        regSubmitButton.disabled = false;
        regSubmitButton.removeAttribute("aria-busy");
      }
    }
  }

  // Function to process the response based on result_type
  function processResult(data, regNumber) {
    if (!collectionInfo) return;

    const resultType = String(data.result_type); // Ensure it's a string
    const { title, image, handle, make, model, year, colour } = data;

    let htmlContent = "";

    if (["1", "2", "3", "4"].includes(resultType) && handle) {
      // Category found / make available / ktype fallback / vehicle not found,
      // but still have somewhere useful to send the customer
      htmlContent = `
                <div class="collection-details">
                    ${
                      image
                        ? `<img src="${image}" alt="Category Image" class="imgreglookup">`
                        : ""
                    }
                    <h5 class="collection-title">${title}</h5>
                    <div class="button-group">
                        <button class="button-primary" onclick="window.location.href='/collections/${handle}';">View Products</button>
                        <span class="reset-button" onclick="resetForm()">Reset</span>
                    </div>
                </div>
            `;

      // Only remember this search if a real vehicle was actually identified
      // (make and/or model present). A gibberish/unrecognised reg still gets
      // shown this fallback page (so the customer has somewhere useful to
      // go), but it shouldn't clutter their recent-searches list.
      if (make || model) {
        saveGuestHistory({
          reg: regNumber.toUpperCase(),
          title: title || "",
          make: make || "",
          model: model || "",
          year: year || "",
          colour: colour || "",
          image: image || "",
          handle: handle,
          searched_at: new Date().toISOString(),
        });
      }
    } else {
      htmlContent = `
                <div class="collection-details">
                    <h5>Unexpected response received. Please try again later.</h5>
                    <div class="button-group">
                        <span class="reset-button" onclick="resetForm()">Reset</span>
                    </div>
                </div>
            `;
    }

    // Update the collectionInfo div with the generated content
    collectionInfo.innerHTML = htmlContent;
    showDropdown();
  }

  // Reset function
  function resetForm() {
    regInput.value = ""; // Clear the input field
    if (collectionInfo) collectionInfo.innerHTML = ""; // Clear the collection info
    if (recentList) recentList.style.display = "";
    renderRecentList();
  }

  // Attach the function to the global scope for button onclick
  window.lookupCar = lookupCar;
  window.resetForm = resetForm;
});
